module.exports = function (fox) {
	'use strict';
	require('./widget/personalData')(fox);
	require('fox-dynamic-injection!fox-template-loader!./templates/personal-data.tpl')(fox);
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR/index.es.js